import { useEffect } from 'react';
import { useAuth } from './useAuth';
import { hasAuthParams } from './hasAuthParams';
import { auth0Client } from './auth0Client';
import { consumeReLoginRequired } from './reLoginRequired';

export function useLoginRequired() {
  const { login } = useAuth();
  useEffect(() => {
    (async () => {
      if (hasAuthParams()) {
        return;
      }
      if (consumeReLoginRequired()) {
        // 統合失敗後のテナントセッションをサイレント認証で引き継がないよう、アカウントの再選択を要求する
        await auth0Client.loginWithRedirect({
          authorizationParams: {
            redirect_uri: `${window.location.origin}/home`,
            prompt: 'login',
          },
        });
        return;
      }
      await auth0Client.checkSession();
      const user = await auth0Client.getUser();
      if (!user) {
        await login();
      }
    })();
  }, [login]);
}
